<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar
      @search="fetchData"
      @handleAdd="onAdd"
      @opentitleForm="opentitleForm"
    />

    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column label="位置" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.row.infoType == 1 ? '注册' : '个人信息' }} -->
          <span v-if="scope.row.infoType == 1">注册</span>
          <span v-else-if="scope.row.infoType == 2">个人信息</span>
          <span v-else-if="scope.row.infoType == 3">推荐</span>
          <span v-else-if="scope.row.infoType == 4">邀请注册</span>
          <span v-else-if="scope.row.infoType == 5">推荐物业服务</span>
          <span v-else-if="scope.row.infoType == 6">酒店宴会服务</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="创建人" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.creator) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.creationTime }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div class="lastBtn">
            <el-button size="small" @click="editCell(scope.row)" type="text"
              >编辑</el-button
            >
            <el-button size="small" @click="delCell(scope.row)" type="text"
              >删除隐私条例</el-button
            >
          </div>
          <!-- <div class="lastBtn">
            <el-button size="small" @click="editContent(scope.row)" type="text"
              >编辑内容</el-button
            >
            <el-button
              size="small"
              @click="addContent(scope.row.helpId)"
              type="text"
              >新增内容</el-button
            >
          </div> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <!-- <Pagination ref="Pagination" /> -->

    <!-- 标题对话框 -->
    <!-- <titleForm ref="titleForm" @fetchData="fetchData" /> -->

    <!-- 内容对话框 -->
    <!-- <contentForm ref="contentForm"  @fetchData="fetchData" /> -->

    <!-- 修改表单对话框 -->
    <editPolicy ref="editPolicy" />
  </div>
</template>

<script>
import {
  privacyList,
  privacyGetContent,
  privacyRemove,
} from '@/api/privacyPolicy.js';
// const titleForm = () => import('./components/titleForm') // 标题对话框
// const contentForm = () => import('./components/contentForm') // 内容对话框
import SearchBar from './components/searchBar'; // 搜索框
import editPolicy from './components/editPolicy';
import { decrypt } from '@/utils/encryp';

export default {
  name: 'Message',
  components: {
    // titleForm,
    // contentForm,
    SearchBar,
    editPolicy,
  },
  data() {
    return {
      list: [],
      listLoading: false,
      editShow: true,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      statuList: ['编辑中', '已发布', '已删除'],
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData(obj = {}) {
      try {
        this.listLoading = true;
        // status ->  1.编辑中， 2.已发布， 3.已删除
        let res = await privacyList({
          ...obj,
        });
        if (res.code !== 200) return;
        this.listLoading = false;
        this.list = res.data.dataList;
      } catch (e) {
        window.console.log(e);
      }
    },
    // 增加
    onAdd() {
      this.$refs.editPolicy.dialogFormVisible = true;
    },
    opentitleForm() {
      this.$refs.editPolicy.dialogFormVisible = true;
    },
    // 编辑标题
    editCell(row) {
      this.$refs.editPolicy.editForm = {
        // 编辑表单
        infoType: row.infoType,
        name: row.name,
        id: row.id,
        content: row.content,
      };
      // console.log('编辑表单', this.$refs.editPolicy.editForm);
      this.$refs.editPolicy.dialogFormVisible = true;
    },

    // 删除标题
    async delCell(row) {
      try {
        if (row.status === 3) return this.$message.warning('已是删除状态');
        this.$confirm('删除标题会及其内容也删除，您确定还要删除吗？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await privacyRemove(row.id);
            if (res.code !== 200) return;
            this.$message.success('删除成功！');
            this.fetchData();
          })
          .catch(() => {});
      } catch (e) {
        window.console.log(e);
      }
    },

    // 编辑内容
    async editContent(row) {
      try {
        // 获取内容
        await privacyGetContent(row.helpId).then((res) => {
          if (res.code !== 200) return;
          // 设置内容
          let newList = res.data.map((item) => {
            return {
              answer: item.answer,
              question: item.question,
              contentId: item.contentId,
              status: item.status,
            };
          });
          this.$refs.contentForm.titleName = '编辑';
          this.$refs.contentForm.form = {
            helpContent: newList,
            helpId: row.helpId,
            status: row.status,
          };
          this.$refs.contentForm.dialogFormVisible = true;
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    addContent(id) {
      this.$refs.contentForm.titleName = '新增';
      //初始化数据
      this.$refs.contentForm.form = {
        status: '',
        helpId: id,
        helpContent: [{ question: '', answer: '答:', status: '' }],
      };
      this.$refs.contentForm.dialogFormVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}
</style>
